import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/commons/plugins/plugins.class.ts' );

import { Constants } from "../Constants";
import * as _ from 'lodash';
import { Subscription } from "rxjs";

import { PluginManagerService } from '@src/app/service/plugin-manager.service';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';
import { XsEventListenerInterface } from '@src/app/xs/interfaces/event-listener.interface';
import { XsApplicationEventsService } from '@src/app/xs/services/events/application-events.service';
import { XsAwait } from '@src/app/xs/controllers/await.class';

const Cesium = (<any>window).Cesium


export class FdmPluginInterface {
    show:boolean = false;
    static meta:any = null;
    init() {}
}
export class FdmPluginConfig {
    name:string = null;
    id:string = null;
    type = ['']
}
export class FdmPlugin implements XsIdentityInterface, XsEventListenerInterface {
    [x: string]: any;

    __ID      = null;
    __EVENTS  = null;



    // Plugin category
    static category = {
        all: 'PLUGINS.CATEGORY.ALL',
        advanced: 'PLUGINS.CATEGORY.ADVANCED',
        beta: 'PLUGINS.CATEGORY.BETA',
        deprecated: 'PLUGINS.CATEGORY.DEPRECATED',
        debug: 'PLUGINS.CATEGORY.DEBUG',
        experimental: 'PLUGINS.CATEGORY.EXPERIMENTAL',
        generic: 'PLUGINS.CATEGORY.GENERIC',
        internal: 'PLUGINS.CATEGORY.INTERNAL',
        technical: 'PLUGINS.CATEGORY.TECHNICAL',
    };

    // plugin domain (classes, extended category)
    static domain = { 
        visualize:'visualize',
        movement:'movement',
    };

    // plugin types
    static types = { 
        allController:'all-controller',
        transformController:'transform-controller',
        annotationController:'annotation-controller',
        cameraController: 'camera-controller',
        sceneController: 'scene-controller',
        projectController: 'project-controller',
        mapController: 'map-controller',
        basemapController: 'basemap-controller',
        entityController: 'entity-controller',
        coordController: 'coord-controller',
        imageController: 'image-controller',
        bucketsController: 'buckets-controller',
    };

    // static plugin names
    static kind = { 
        timeController:'time-controller',
    };
    
    // plugin features
    static features = {
        all:'all',
        show:'show',
        pulse:'pulse',
        startstop:'startstop',
        configuration:'configuration',
        mouseControl:'mouseControl',
        interaction:'interaction',
    }

    // Transform types
    static tr_types = {
        all:'all',
        three_d_tiles:'three-d-tiles',
        terrain_tiles: 'terrain-tiles',
        public_3d:'public-3d',
        wms_remote:'wms-remote'
    };

    // Dataset types (that plugins may know how to deal with)
    static ds_types = {
        all:'all',
        dwg:'dwg',
        laslaz_tiles:'laslaz-tiles',
        csv:'csv',
        text:'text',
        kml: 'kml',
        geo_json: 'geo-json',
        geotif: 'geotif',
        pdf:'pdf',
        fbx:'fbx',
        dxf:'dxf',
        xml_blocks:'xml-blocks',
        ifc:'ifc',
        dae:'dae',
        obj:'obj',
        three_d_tiles:'three-d-tiles',
        public_3d:'public-3d',
        photo: 'photo',
        jp2:'jp2',
        ecw:'ecw',
        ply:'ply',
        e57:'e57',
        laslaz:'laslaz',
        tms:'tms',
        shape_zip:'shape-zip',
        wfs:'wfs',
        wms:'wms'
    };

    // how does the plugin fit into the world?
    static cardinality = {
        there_can_only_be_one: 'only-one',  // only one of these ever at the same time in the whole world!
        singleton:'singleton',              // only one of these plugins can be running at the same time
        one:'one',                          // only one of these associated with their type object
        multiple:'multiple'                 // multiple of these plugins can attach to their object
    }

    debug:boolean = Constants.debug_off;
    debugPrimary:string = Constants._red;
    debugSecondary:string = Constants._black;

    debugToken:string = null;
    debugPerformance = null;
    debugSection:string = null;

    timeCreated:any = null;

    // our meta configuration
    meta:any = {};

    // any injected further config
    config:any = {};

    // subscriptions to stuff
    _subs:Subscription[] = [];

    ontology:any = [];
    plugin_name:string = '';

    // unique identifier of plugin instance
    id:string = this.uuidv4();

    // name / type of instance
    name:string = '';

    // if a plugin is attached to any item (Transform, Annotation, etc.), their id is stored here
    item:any = null;
    itemId:string = null;
    itemData:any = null;

    // if this plugin is managed by a controller
    controller:any = null;

    // a plottable reference object (usually from CesiumHelper, like entities, imageLayers, etc.)
    object:any = null;

    // what we control with this plugin
    entities:any = {};

    // if entities needs a cleanup after we remove the plugin
    entitiesDirty:boolean = false;

    // options for different kinds of entity configurations
    entityTypes:any = {};
    entityTypeCounter:number = 0;

    // some incoming objects might have a boundingSphere (to mark the center of a complex entity)
    boundingSphere:any = null;

    // various options (set them up in your init() method to avoid odd overrides)
    options:any = {
        // just a default, empty, non-selected type
        type: { current:null, items: [] },
        entityType: { current:null, items: [] }
    };

    // if we have any controls (for UI manipulation)
    controls:any = {};
    controlsDirtyHash:string = null;
    controlsDirty:boolean = false;

    // we can control our controls by their feature groupings
    features:any = {};

    // sometimes we inject something extra, like an object, or parameters, or whatever, and it ends up here
    extra:any = null;

    // some UI controls
    show:boolean = false;

    // when we show/hide, we can ignore some entities
    ignoreShowHide:any = {};

    // is there a primary entity?
    primed:any = null;

    autoPrime:string = 'primary';

    // supported injectable classes (we may not be using this one anymore)
    injectors:string[] = ['pluginManager','mapService','coordHelper','fourD','dialog','fileManager','entityHelper','measureHelper','translate','sceneController','uiManager'];

    // finale!
    finalisers:any[] = [];

    // support for pulsating action
    blip:boolean = false;
    interval:any = null;
    pulseSeconds:number = 4;
    pulsing:boolean = false;

    noflow:any = null;

    // shortcut back to the PluginManager
    services:any = null;

    // shortcut to the application events
    applicationEvents:any = null;

    // a plugin can have offspring ...
    plugs:any = null;

    // are we trying to shut down?
    shutdown:boolean = false;

    // if plugin has finished running all the constructs and inits (including the user's overridden ones)
    doneInit:boolean = false;

    __log ( section:string, data:any = null ) {
        if ( data ) {
            console.log ( '%c '+this.debugToken+' %c '+this.__runningTime()+'ms %c '+section+' ', this.debugPrimary, Constants._gray, this.debugSecondary, data );
        } else {
            console.log ( '%c '+this.debugToken+' %c '+this.__runningTime()+'ms %c '+section+' ', this.debugPrimary, Constants._gray, this.debugSecondary );
        }
    }

    __runningTime() {
        return Math.floor(performance.now() - this.timeCreated); // ).split('.')[0];
    }

    constructor ( pm: PluginManagerService ) {

        if ( !this.timeCreated ) {
            this.timeCreated = performance.now();
        }

        this.services = pm;
        this.applicationEvents = this.services.applicationEvents;

        this.__ID = XsIdentityInterface.__init(this);
        this.__EVENTS = XsEventListenerInterface.__init(this);

        this.initialInternalConstruct();
    }

    // we've got a few internal constructs to make up for JS / TS slow prototyping building times

    initialInternalConstruct() {

        // fetch meta data name from static configuration
        let test = (<any>this.constructor).meta;
        this.meta = test;
        if ( test.name ) {
            this.plugin_name = test.name;
        }

        this.debugToken = this.__ID.id;

        // mini-delay for letting the constructors build
        setTimeout ( () => { this.internalConstruct(); }, 10 );
    }

    internalConstruct() {

        // overridable
        this.construct();

        // add slight delay to let the JS engine prototype it up properly
        setTimeout ( () => {

            // initialise some constructs (like controls, etc.)
            this.internalInit();

        }, 50 );
    }

    // before any initialising, you can override this one
    construct() {}

    internalInit() {
        
        let pre = this.meta.translator;
        // console.log('############### internalInit()', this, pre );
        
        if ( pre ) {
            // let list = [ pre+'.LABEL' ];
            let groups = {};
            Object.keys(this.controls).forEach(key => {

                this.controls[key]['uuid'] = this.id + '_' + key;

                if ( !this.controls[key].hasOwnProperty('noshow') ) {
                    this.controls[key]['noshow'] = false; 
                }

                if ( !this.controls[key].hasOwnProperty('translateOptions') ) {
                    this.controls[key]['translateOptions'] = true; 
                }

                this.controls[key]['name'] = pre + '.' + key.toUpperCase(); 

                if ( this.controls[key].hasOwnProperty('translate') ) {
                    this.controls[key]['name'] = pre + '.' + this.controls[key]['translate'].toUpperCase(); 
                }
                
                // list.push(pre+'.'+key.toUpperCase());
                if ( this.controls[key].group ) {
                    groups[this.controls[key].group] = this.controls[key].group;
                }

            });
            // Object.keys(groups).forEach(key => {
            //     list.push(pre+'.GROUP_'+key.toUpperCase());
            // });
            // console.log('###############', list );

            /*
            this.services.translate.get(list).subscribe(translated => {
                // console.log('@@@@@@@@@@@@@@@@@@', translated );
                if ( translated[pre+'.LABEL']) {
                    this.meta.label = translated[pre+'.LABEL'];
                }
                Object.keys(this.controls).forEach(key => {
                    let k = pre+'.'+key.toUpperCase();
                    if ( k != translated[k] ) {
                        this.controls[key].name = translated[k];
                    }
                    if ( this.controls[key]['group'] ) {

                        let g = this.controls[key]['group'].toUpperCase();
                        let f = pre+'.GROUP_'+g;

                        // console.log('$$',key, g, f);
                        if ( translated[f] ) {
                            this.controls[key]['group'] = translated[f];
                        }
                    }
                });
            }); */
        }

        // initialise the plugin
        this.init();

        this.doneInit = true;
    }
    
    // override at will
    init() {}
    end() {}

    // override for resetting the plugin
    reset() {}



    // calculations

    calculating:boolean = false;
    calculateCurrent:number = 0;
    calculateTotal:number = 0;
    calculatePercent:number = 0;

    startCalculating ( total:number = 1 ) {
        this.calculating = true;
        this.calculateCurrent = 0;
        this.calculateTotal = total;
    }

    endCalculating () {
        this.calculating = false;
    }

    cancelCalculating () {
        this.calculating = false;
    }

    updateCalculationProcess ( current:number ) {
        setTimeout( () => {
            this.calculateCurrent = current;
            this.calculatePercent = ( ( this.calculateCurrent * 100 ) / this.calculateTotal);
        }, 10 );
    }

    // default is browser id/name safe (underlines and prefix)
    uuidv4( token:string = '_', prefix:string = 'uuid_') {
        return ( prefix + 'xxxxxxxx'+token+'xxxx'+token+'4xxx'+token+'yxxx'+token+'xxxxxxxxxxxx').replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    updateConfig ( config:any = null ) {
        this.config = config;
    }

    // override at will; configure is when the configure button is hit
    configure() {}

    // restore is when the restore (saved data) from item button is hit
    restore() {
        this.load(true);
    }

    // override for refreshing it (unless you just use showHide())
    refresh(newvalue = null, section:any = null) {
        if ( section ) {
            if ( !section['noflow'] ) {
                section.value = newvalue;
                this.noflow = false;
            } else {
                section.hiddenValue = newvalue;
                this.noflow = section;
            }
        } 
    }

    destroy() {

        this.shutdown = true;

        // console.log ( '%c plugin ['+this.plugin_name+'] %c '+this.runningTime()+'ms %c destroy()', this.debugPrimary, Constants._pink, this.debugSecondary );
        // this.__log('destroy() start');

        // first, finalizers ... (usually used to close down stuff)
        if ( this.finalisers ) {
            this.finalisers.forEach ( e => { 
                if ( e ) {
                    e.call();
                }
            });
        }

        // any endings?
        this.end();

        // reset and clean up
        this.reset();
        this.stopPulse();
        this.wipe();

        // kill all plugs attached
        this.deletePlugs();
        
        // kill all residue
        this.deleteSubscriptions();

        if ( this.__EVENTS ) {
            XsEventListenerInterface.__destroy(this);
        }
        
        // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c destroy() DONE, SQUEEKY CLEAN', this.debugPrimary, this.debugSecondary ); }
        // this.__log('destroy() end');
        // console.log ( '%c plugin ['+this.plugin_name+'] %c '+this.runningTime()+'ms %c destroy() DONE, SQUEEKY CLEAN', this.debugPrimary, Constants._pink, this.debugSecondary );

    }




    // plugs are a simplified set of plugins directly in control of only this Plugin

    updatePlug ( plugName:string = null, data:any = null ) {

        // this.__log('updatePlug() start', [ plugName, data ] );
        // console.log('@@PLUGS updatePlug() BEGIN', plugName, data );

        if ( !plugName ) {
            // console.log('@@PLUGS updatePlug() NONAME', plugName, data );
            return null;
        }
        let plugConfig = this.plugs ? this.plugs[plugName] : null;

        // no plug, no data; do nothing
        if ( !plugConfig && !data ) {
            // console.log('@@PLUGS updatePlug() NO_PLUG && NO_DATA', plugName, data );
            return null;
        }

        if ( !plugConfig && data ) {
            this.createPlug(plugName);
        } else if ( plugConfig && !data ) {
            this.deletePlug(plugName);
        }

        plugConfig = this.plugs ? this.plugs[plugName] : null; // refresh

        if ( plugConfig && plugConfig['object'] ) {
            // this.__log('updatePlug() values injected', [ plugName, data ] );
            // console.log('@@PLUGS updatePlug() values injected', plugName, data );
            plugConfig.object.valuesInjected(data);
        }
    }

    createPlug ( plugName:string = null ) {
        if ( !plugName ) {
            return null;
        }

        // this.__log('createPlug() start', [ plugName ] );

        let id = this.services.create(plugName);
        
        // console.log('@@PLUGS createPlug() create', plugName, id );
        
        if ( id ) {
            if ( !this.plugs ) {
                this.plugs = {};
            }
            this.plugs[plugName] = { 
                id: id, 
                object: this.services.get(id),
                show: false
            };

            XsAwait.until( 'doneInit', this, 50 ).then ( _ => {
                if ( this.plugs[plugName].object ) {
                    if ( this.object ) {
                        this.plugs[plugName].object.injectObject( this.object );
                    }
                    if ( this.item ) {
                        this.plugs[plugName].object.injectItem( this.item );
                    }
                }
            });
            
        }
        // this.__log('createPlug() end', [ plugName, id ] );
        // console.log('@@PLUGS createPlug() check', plugName, this.plugs[plugName] );
    }

    getPlug ( plugName:string = null ) {
        // console.log('@@PLUGS getPlug()', plugName );
        if ( !plugName || !this.plugs ) {
            return null;
        }
        let plugConfig = this.plugs[plugName];
        if ( plugConfig ) {
            return plugConfig.object;
        }
    }

    deletePlug ( plugName:string = null ) {
        // console.log('@@PLUGS deletePlug()', plugName );
        // this.__log('deletePlug()', [ plugName ] );
        if ( !plugName ) {
            return null;
        }
        let plugConfig = this.plugs[plugName];
        if ( plugConfig ) {
            let p = this.services.get(plugConfig.id);
            p.destroy();
            delete plugConfig.object;
            this.plugs[plugName] = null;
            delete this.plugs[plugName];
            // this.__log('deletePlug() DELETED', [ plugName ] );
            // console.log('@@PLUGS deletePlug() DELETED', plugName );
            if ( Object.keys(this.plugs).length == 0 ) {
                this.plugs = null;
            }
        }
    }

    deletePlugs() {
        if ( this.plugs ) {
            const these = Object.keys(this.plugs);
            // console.log('@@PLUGS deletePlugs()', these );
            these.forEach( plugName => { 
                this.deletePlug(plugName);
            });
        }
    }

    // CSS linear scale colors (overwrite if you got them)
    linearScale ( name:string = 'default' ) { return []; }
    linearScaleHeight( scale:number = 1 ) { return scale+'px'; }

    // UI interactions; overwrite at will
    incomingAction ( value:any, section:any ) {}



    // this components various subscriptions to events
    addSubscription ( f:any ) {
        this._subs.push(f);
    }

    // delete all of them
    deleteSubscriptions() {
        this._subs.forEach(sub => sub.unsubscribe());
    }



    injectItem ( item:any = null ) {
        this.item = item;
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c injectItem()', this.debugPrimary, this.debugSecondary, this.item ); }
        setTimeout ( () => {
            if ( this.item ) {
                this.internItemInjected ();
                this.findAndInjectObject();
            }
            this.refresh();
        }, 110 );
    }

    findAndInjectObject () {
        if ( !this.item || !this.item.className ) {
            return false;
        }
        let object = this.services.cesiumHelper.getMapObjectFor ( this.item );
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c findAndInjectObject()', this.debugPrimary, this.debugSecondary, object ); }
        if ( object && object.object ) {
            this.object = object.object;
            this.internObjectInjected();
        }
    }

    injectObject ( object:any = null ) {
        this.object = object;
        this.internObjectInjected();
    }

    internItemInjected () {
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c internItemInjected()', this.debugPrimary, this.debugSecondary, this.isInItem() ); }
        if ( this.isInItem() ){
            this.load();
        } else {
            this.save();
        }
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c internItemInjected() INJECTED', this.debugPrimary, this.debugSecondary, this.itemData ); }
        this.itemInjected();
    }

    internObjectInjected () {
        if ( this.object && this.object.boundingSphere ) {
            this.boundingSphere = this.object.boundingSphere;
        }
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c internObjectInjected()', this.debugPrimary, this.debugSecondary, this.object ); }
        this.objectInjected();
    }

    

    // when we're injected to an Item, see if there's some state in there for us
    // override for injecting Transform/Annotation, whatevers, and try to get CesiumHelper objects from it
    objectInjected () {}
    itemInjected() {}


    // pokes are events hitting this plugin if it's registered against an GUID object
    // defaults to do nothing, overwrite it to catch it
    tell ( action:string = 'update', data:any = null ) {}

    has ( feature:string ) {
        let test = (<any>this.constructor).meta;
        // if ( feature == 'pulse' ) { console.log ( '@@@@@@', feature, test ); }
        if ( test && test['features'] && Array.isArray(test['features']) ) {
            if ( test['features'].find( f => f == feature )) {
                return true;
            }
        }
        return false;
    }

    startPulse() {
        this.pulsing = true;
        this.interval = setInterval( () => { this.internPulse() }, this.pulseSeconds * 1000);
    }

    stopPulse() {
        this.pulsing = false;
        if ( this.interval ) {
            clearInterval( this.interval );
        }
    }

    internPulse() {
        this.blip = true;
        this.pulse();
        setTimeout ( () => {
            this.internPulseOff();
        }, 999);
    }
    internPulseOff() {
        this.blip = false;
        this.pulseOff();
    }
    pulse() {}
    pulseOff() {}




    // hackish support for a bigger pulse (used for more API parsing and long-term stuff)
    bigPulsing:boolean = false;
    bigInterval:any = null;
    bigPulseSeconds:number = 30;
    bigBlip:boolean = false;

    startBigPulse() {
        this.bigPulsing = true;
        this.bigInterval = setInterval( () => { this.internBigPulse() }, this.bigPulseSeconds * 1000);
    }

    stopBigPulse() {
        this.bigPulsing = false;
        if ( this.bigInterval ) {
            clearInterval( this.bigInterval );
        }
    }

    internBigPulse() {
        this.bigBlip = true;
        this.bigPulse();
        setTimeout ( () => {
            this.internBigPulseOff();
        }, 999);
    }
    internBigPulseOff() {
        this.bigBlip = false;
        this.bigPulseOff();
    }
    bigPulse() {}
    bigPulseOff() {}




    noshowControl ( key:string, these:string[] = [] ) {
        if ( this.controls[key] ) {
            if ( this.controls[key].value ) {
                this.turnOn(these);
            } else {
                this.turnOff(these);
            }
        }
    }

    turnNoshow ( controls:string[] = null, state:boolean = true, andFeatures:string[] = null ) {
        if (!controls ) {
            controls = Object.keys(this.controls);
        }
        controls.forEach( key => {
            if ( this.controls[key] ) {
                if ( !andFeatures ) {
                    // console.log('#key',key,state);
                    this.controls[key].noshow = state;
                } else {
                    if ( this.controls[key]['feature'] && andFeatures.find( f => this.controls[key]['feature'] == f ) ) {
                        // console.log('#feature',key,state);
                        this.controls[key].noshow = state;
                    }
                }
            } else {
                // console.log('#noKey',key);
            }
        });
    }

    turnOnFeatures ( features:string[] ) {
        this.turnNoshow ( null, false, features );
    }

    turnOffFeatures ( features:string[] ) {
        this.turnNoshow ( null, true, features );
    }

    turnOn ( controls:string[] = [] ) {
        this.turnNoshow ( controls, false );
    }
    turnOff ( controls:string[] = [] ) {
        this.turnNoshow ( controls, true );
    }
    turnOffAllBut ( me:string = null ) {
        let these = [];
        Object.keys(this.controls).forEach ( key => {
            if ( key !== me ) {
                these.push(key);
            }
        })
        this.turnNoshow ( these, true );
    }
    turnOnAllBut ( me:string = null ) {
        let these = [];
        Object.keys(this.controls).forEach ( key => {
            if ( key !== me ) {
                these.push(key);
            }
        })
        this.turnNoshow ( these, false );
    }
    transferControlValuesToObject ( object:any = null, these:string[] = null ) {
        if ( object && these ) {
            these.forEach ( me => {
                object[me] = this.controls[me].value;
            });
        }
    }

    transferControlValues ( token:string = null, these:string[] = null ) {
        if ( token && these ) {
            these.forEach ( me => {
                this.controls[token][me] = this.controls[me].value;
            });
        }
    }

    entity ( id:string = null, e:any = null ) {
        if ( !id || id == 'undefined' ) {
            return null;
        }
        if ( id && e ) {
            // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c entity() ADD', this.debugPrimary, this.debugSecondary, id, e ); }
            this.entities[id] = e;
            if ( this.autoPrime && id == this.autoPrime ) {
                this.primed = e;
            }
        } else if ( id && this.entities[id] ) {
            // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c entity() GET', this.debugPrimary, this.debugSecondary, id, this.entities[id] ); }
            return this.entities[id];
        }
    }

    setupOption ( what:string, options:any[] = [] ) {
        
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c setupOption()', this.debugPrimary, this.debugSecondary, what, options ); }

        this.options[what].items = options;

        if ( ! this.options[what].current ) {
            this.options[what].current = this.options[what].items.length > 0 ? this.options[what].items[0] : null;
        }

    }

    addEntityType ( name:string, obj:any ) {
        obj['_eid'] = this.entityTypeCounter++;
        this.entityTypes[name] = obj;
        this.entityTypes[name]._type = name;
        // if ( this.debug ) { console.log ( '%c plugin %c addEntityType()', this.debugPrimary, this.debugSecondary, name, obj ); }
    }

    getEntityType ( name:string, addOn:any = {} ) {
        let config = this.entityTypes[name] ? this.entityTypes[name] : {};
        Object.keys(addOn).forEach(key => {
            config[key] = addOn[key]
        });
        // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c getEntityType()', this.debugPrimary, this.debugSecondary, name, config ); }
        return config;
    }

    // destroy all evidence
    wipe () {

        Object.keys(this.entities).forEach(key => {
            this.wipeEntity ( key );
        });
        this.entities = {};
        this.primed = null;
    }

    wipeEntity( key:string ) {
        let e = this.entities[key];
        if ( e ) {
            if ( Array.isArray(e) ) {
                if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c wipeEntity() ARRAY '+key, this.debugPrimary, this.debugSecondary, e.length ); }
                e.forEach ( p => { 
                    if ( p ) { this.services.mapService.viewer.entities.remove( p ) }; 
                });
                this.entities[key].length = 0;
            } else {
                if ( this.debug ) { 
                    let c = this.services.mapService.viewer ? this.services.mapService.viewer.entities : null;
                    console.log ( '%c plugin ['+this.plugin_name+'] %c wipeEntity() ENTITY '+key, this.debugPrimary, this.debugSecondary, c, this.services.mapService.viewer, e ); // }
                }
                this.services.mapService.viewer.entities.remove( e );
            }
            this.entities[key] = null;
            delete ( this.entities[key] );
        }
    }

    showHide( state:boolean = this.show ) {

        // new state
        this.show = state;

        Object.keys(this.entities).forEach(key => {
            let e = this.entities[key];
            if ( e && ! this.ignoreShowHide.hasOwnProperty(key) ) {
                if ( Array.isArray(e) ) {
                    if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c showHide() ARRAY '+key, this.debugPrimary, this.debugSecondary, state, e.length ); }
                    e.forEach ( p => { 
                        if ( p ) { p.show = state }; 
                    });
                } else {
                    if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c showHide() ENTITY '+key, this.debugPrimary, this.debugSecondary, state, e ); }
                    e.show = state
                }
            }
        });
        
    }

    flyTo( who:string = 'primary' ) {
        let e = this.findEntity(who);
        if ( e ) {
            if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c flyTo() entity', this.debugPrimary, this.debugSecondary, who, e ); }
            this.services.mapService.viewer.flyTo( e );
        }
    }

    zoomTo( who:string = 'primary' ) {
        let e = this.findEntity(who);
        if ( e ) {
            if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c flyTo() entity', this.debugPrimary, this.debugSecondary, who, e ); }
            this.services.mapService.viewer.zoomTo( e );
        }
    }

    findEntity( who:string = 'primary' ) {
        let e = null;
        if ( this.entities[who] ) {
            e = this.entities[who];
        } else {
            Object.keys(this.entities).forEach(key => {
                e = this.entities[key];
                return;
            });
        }
        return e;
    }

    pickTransformEntity ( position:any = null ) {

        let find = this.services.mapService.viewer.scene.pick( position );

        if ( find ) {
            // console.log ( '$$$', find );
        }

        if ( find && find.id && find.id.point ) {

            let entity = find.id;

            if (Cesium.defined(entity) && entity['_transformId']) {
                return entity;
            }
        }

        return null;
    }

    getSceneId() {
        if ( !this.services.mapService || !this.services.mapService.scene ) {
            return false;
        }
        return this.services.mapService.scene.id;
    }

    hasBackupInItem() {
        let sceneId = this.getSceneId();
        // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c hasBackupInItem()', this.debugPrimary, this.debugSecondary, sceneId, this.item['_plugins'], this.meta.name ); }
        if ( this.item && sceneId && this.item['_plugins'] && this.item['_plugins'][sceneId] && this.item['_plugins'][sceneId][this.meta.name+'-backup'] ) {
            return true;
        }
        return false;
    }
    isInItem() {
        
        let sceneId = this.getSceneId();

        // if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c isInItem()', this.debugPrimary, this.debugSecondary, sceneId, this.item['_plugins'], this.meta.name ); }
        
        if ( this.item && sceneId && this.item['_plugins'] && this.item['_plugins'][sceneId] && this.item['_plugins'][sceneId][this.meta.name] ) {
            return true;
        }
        return false;
    }

    // override if needed; mostly does nothing, but it's called after every control has done some work, so if you want
    // to process and prep something for saving, and then save some state, then here's your chance
    // saving the state of the plugin to an Item

    save( extra:any = null ) {
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c save()', this.debugPrimary, this.debugSecondary ); }        
        this.saveToItem(extra);
    }
    load ( loadFromBackup:boolean = false ) {
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c load()', this.debugPrimary, this.debugSecondary ); }        
        return this.loadFromItem ( loadFromBackup );
    }


    loadBefore() {}
    loadAfter() {}

    // load state from attached Item
    loadFromItem( loadFromBackup:boolean = false ) {
        let sceneId = this.getSceneId();
        let plugin = null;
        let finalName = this.meta.name;
        this.loadBefore();
        if ( loadFromBackup ) {
            finalName = finalName + '-backup';
        }
        if ( this.item && sceneId && this.item['_plugins'] && this.item['_plugins'][sceneId] && this.item['_plugins'][sceneId][finalName] ) {
            plugin = this.item['_plugins'][sceneId][finalName];
            if ( plugin['controls'] ) {

                Object.keys(plugin['controls']).forEach ( key => {
                    // if ( !this.controls[key] ) {
                    //     this.controls[key] = { value:null, _autofield:true };
                    // }
                    if ( this.controls.hasOwnProperty(key) ) {
                        this.controls[key].value = plugin['controls'][key];
                    } 
                });
            }
            // console.log('#### LOAD_FROM', plugin );
            if ( plugin['extra'] ) {
                try {
                    this.itemData = JSON.parse(plugin['extra']);
                } catch (error) {
                    console.info('plugins.loadFromItem() : Extra JSON not parsed', this.item['id'], plugin['extra'] ); 
                }
            }
        }

        this.loadAfter();
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c loadFromItem()', this.debugPrimary, this.debugSecondary, sceneId, this.item, plugin ); }
    }

    // overridable delete
    deleting() {}
    
    // remove from item
    deleteFromItem () {
        let sceneId = this.getSceneId();
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c deleteFromItem()', this.debugPrimary, this.debugSecondary, sceneId ); }
        this.deleting();
        if ( this.item && sceneId && this.item['_plugins'] && this.item['_plugins'][sceneId] && this.item['_plugins'][sceneId][this.meta.name] ) {
            // we set it to 'delete' instead of deleting the property, as the saving will remove it
            this.item['_plugins'][sceneId][this.meta.name+'-backup'] = this.item['_plugins'][sceneId][this.meta.name];
            this.item['_plugins'][sceneId][this.meta.name] = 'delete';
            if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c deleteFromItem() DELETED', this.debugPrimary, this.debugSecondary, sceneId ); }
        }
        this.saveToItem();
    }

    saveBefore() {}
    saveAfter() {}

    // save plugin state to an Item
    saveToItem ( extra:any = null ) {
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c saveToItem() START', this.debugPrimary, this.debugSecondary, extra ); }        
        let sceneId = this.getSceneId();
        let p = {};
        this.saveBefore();
        if ( this.item && sceneId ) {
            if ( ! this.item['_plugins'] ) {
                this.item['_plugins'] = {};
            }
            if ( ! this.item['_plugins'][sceneId] ) {
                this.item['_plugins'][sceneId] = {};
            }
            let plugins = this.item['_plugins'][sceneId];

            // first, save controls values
            if ( this.controls ) {
                p['controls'] = {};
                Object.keys(this.controls).forEach(key => {
                    if ( this.controls[key]._autofield ) {
                        if ( this.controls[key].value ) {
                            p['controls'][key] = this.controls[key].value;
                        }
                    } else {
                        if ( this.controls[key].hasOwnProperty('type') ) {
                            p['controls'][key] = this.controls[key].value;
                        }
                    }
                });
            }

            // then save extra
            p['extra'] = JSON.stringify(this.itemData);
            // if ( extra ) {
            //     p['extra'] = extra;
            // }

            // if we've got data
            if ( plugins[this.meta.name] && plugins[this.meta.name] == 'delete' ) {
                if ( plugins[this.meta.name] ) {
                    delete plugins[this.meta.name];
                }
            } else {
                plugins[this.meta.name] = p;
            }

            // console.log ( "@@@@ SAVE @@@@@@@@@@@@@@@@@", this.item, p );
            if ( this.item.saveObservable ) {
                this.item.saveObservable().subscribe( _ => { this.saveAfter(); });
            }
        }
        if ( this.debug ) { console.log ( '%c plugin ['+this.plugin_name+'] %c saveToItem() END', this.debugPrimary, this.debugSecondary, sceneId, this.item, p ); }
    }


    // super-mini template engine
    parseTemplate ( template:string = '', data:any = {} ) {
        let text = template;
        const arr = ['{','}'];
        let deep = (obj, path) => {
            this.iterateObject(obj, (value, c) => {
                path.push(c);
                if ( typeof value == 'object' ) {
                    deep(value, path);
                    path.pop();
                    return;
                }
                text = text.replace(
                    new RegExp(arr[0] + path.join(".") + arr[1], "gm")
                    , typeof value ? value : String(value)
                );
                path.pop();
            });
        };
    
        deep(data, []);

        return text;
    }

    iterateObject(obj, fn) {
        var i = 0, keys = [];
    
        if (Array.isArray(obj)) {
            for (; i < obj.length; ++i) {
                if (fn(obj[i], i, obj) === false) {
                    break;
                }
            }
        } else if (typeof obj === "object" && obj !== null) {
            keys = Object.keys(obj);
            for (; i < keys.length; ++i) {
                if (fn(obj[keys[i]], keys[i], obj) === false) {
                    break;
                }
            }
        }
    }
    
}

export class FdmBucketPlugin extends FdmPlugin {

    // don't show a header
    hideHeader:boolean = true;

    items:any = [];

    item:any = null;

}


